export enum messages {
  success = 'PAYMENT_IS_SUCCESS',
  loaded = 'UI_LOADED',
}

type successMessage = {
  type: messages.success;
  payload: string;
};

type uiLoadedMessage = {
  type: messages.loaded;
};

export type iFrameMessages = successMessage | uiLoadedMessage;

export const sendSuccess = (email: string): iFrameMessages => ({
  type: messages.success,
  payload: email,
});

export const sendUiLoaded = (): iFrameMessages => ({
  type: messages.loaded,
});
